/**
 * Copyright (c) 2022 Schwäbische Werkzeugmaschinen GmbH
 *
 * @author Sebastian Roming
 * @since 5.0.0
 */
import { css } from 'lit';


export const LdLoginStyles = css`
  body {
    font-family: Calibri, Roboto, Helvetica, sans-serif;
  }

  .ld-login-area {
    width: 40%;
  }

  paper-input {
    --paper-input-container-input-color: var(--paper-grey-600);
  }

  paper-button[disabled] {
    opacity: 0.7;
  }

  .ld-login-area paper-button {
    width: 100%;
    margin: 12px 0;
    background-color: var(--paper-grey-100);
    color: var(--login-button-text-color, var(--sw-primary-highlight-color, #eb0028));
    font-weight: bold;
  }

  paper-button[raised].keyboard-focus {
    background-color: var(--paper-grey-50);
    box-shadow: 0 0 8px #004da3,
    0 0 20px #004da3dd;
  }

  paper-spinner-lite {
    height: 19px;
    width: 19px;
    --paper-spinner-color: var(--login-button-text-color, var(--sw-primary-highlight-color, #eb0028));
  }

  .ld-login-area paper-button.red {
    text-transform: none;
    background-color: var(--paper-grey-800);
    color: white;
  }

  iron-icon {
    color: #949494;
    cursor: pointer;
    margin: 4px;
    margin-top: -2px;
  }

  footer {
    display: -webkit-flex;
    display: flex;
    position: fixed;
    bottom: 0;
    width: 100%;
    -ms-flex-direction: column;
    -webkit-flex-direction: column;
    flex-direction: column;
    -ms-flex-align: end;
    -webkit-align-items: flex-end;
    align-items: flex-end;
    font-size: 12px;
    -ms-flex: 1 1 0px;
    -webkit-flex: 1;
    flex: 1;
    -webkit-flex-basis: 0px;
    flex-basis: 0px;
    margin-right: 60px;
    max-height: 50px;
  }

  footer ul {
    margin: 16px 25px;
    height: 20px;
    list-style: none;
  }

  footer ul>li {
    display: inline;
    margin-right: 15px;
  }

  footer ul>li>a {
    color: #949494;
    text-decoration: none;
  }

  .flex {
    -ms-flex: 1 1 0px;
    -webkit-flex: 1;
    flex: 1;
    -webkit-flex-basis: 0px;
    flex-basis: 0px;
  }

  .passwordForgot {
    font-family: 'Roboto', 'Noto', sans-serif;
    color: var(--platform-legal-text-color, var(--sw-secondary-note-color, #949494));
    cursor: pointer;
    text-align: right;
    font-size: 12px;
  }

  #sw-stripe {
    position: absolute;
    top: 0;
    left: 390px;
    width: 6px;
    height: 100%;
    background-color: var(--login-stripe-background-color, var(--sw-primary-highlight-color, #eb0028));
  }

  #sw-logo {
    font-family: 'Roboto', 'Noto', sans-serif;
    position: absolute;
    top: 220px;
    left: 45px;
    width: 301px;
    height: 162px;
    background-image: url(/assets/sw.png);
    background-size: 301px 162px;
  }

  #lifedata-logo {
    position: absolute;
    top: 220px;
    left: 460px;
    width: 339px;
    height: 119px;
    background-image: url(/assets/lifedata.png);
  }

  section.announcement {
    font-family: Calibri, Roboto, Helvetica, sans-serif;
    color: #856404;
    background-color: #fff3cd;
    border: 1px #ffeeba solid;
    border-radius: 5px;
    padding: 10px;
    margin-bottom: 5px;
  }

  section.message-success {
    background-color: #cdffce;
    border-color: #3f8000;
    color: #3f8000;
  }

  section.message-success a {
    color: #3f8000;
    font-weight: bold;
    text-decoration: none;
    display: block;
  }

  section.message-success a::before {
    content: "» ";
  }

  section.message-error {
    background-color: rgb(255, 189, 189);
    border-color: rgb(180, 0, 0);
    color: rgb(180, 0, 0);
  }

  section.maintenance-announcement p {
    font-weight: bold;
    margin: 0 0 5px 0;
  }

  .ld-login-area {
    position: absolute;
    top: 395px;
    left: 460px;
    width: 340px;
  }

  #privacyPolicyDialog {
    width: 40%;
    min-height: 95%;
  }

  paper-dialog#privacyPolicyDialog .privacy-language {
    margin: 0 0 0 20px;
    padding: 15px 5px 0 5px;
  }

  paper-dialog#privacyPolicyDialog .privacy-language a {
    padding: 0 5px;
  }

  paper-dialog#privacyPolicyDialog .privacy-language a:first-child {
    padding-left: 0;
  }

  paper-toast {
    border-top: 3px var(--login-stripe-background-color, var(--sw-primary-highlight-color, #eb0028)) solid;
  }

  password-compliance-feedback-element {
    position: absolute;
    top: -10%;
    left: 0;
    margin-top: 100px;
    margin-left: 350px;
    height: 200px;
    width: auto;
    min-width: 380px;
  }

  /** TABLET **/
  /** ------------------------------------------------------------------------- **/
  @media (min-width: 768px) and (max-width: 1000px) {
    #sw-stripe {
      left: 190px;
    }

    .ld-login-area {
      width: 50%;
      position: absolute;
      top: 400px;
      left: 250px;
    }

    #sw-logo {
      position: absolute;
      top: 30px;
      left: 250px;
    }

    #lifedata-logo {
      position: absolute;
      top: 220px;
      left: 250px;
    }
  }
  /** SMARTPHONE **/
  /** ------------------------------------------------------------------------- **/
  @media (max-width: 767px) {
    #sw-stripe {
      display: none;
    }

    .ld-login-area {
      position: static;
      width: 80%;
      margin: 50px auto 0 auto;
    }

    #sw-logo {
      position: static;
      margin: 60px auto 0 auto;
      text-align: center;
    }

    #lifedata-logo {
      position: static;
      margin: 30px auto 0 auto;
      text-align: center;
    }
  }
`;
